import { TranslateModule } from '@ngx-translate/core';
import { Maybe, Locale } from '@iss/libs/graphql';
import { FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Component, Inject, Input, Self } from '@angular/core';
import { NgIf } from '@angular/common';

import { AgentInputComponent } from '../agent-input';

import {
  LabelDirective,
  FormFieldComponent,
  FormFieldErrorDirective,
  Control,
  NOOP_VALUE_ACCESSOR,
} from '@iss/core/forms';

@Component({
  selector: 'wo-agent-field',
  templateUrl: './agent-field.component.html',
  standalone: true,
  imports: [
    AgentInputComponent,
    FormFieldComponent,
    FormFieldErrorDirective,
    LabelDirective,
    NgIf,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class AgentFieldComponent {
  @Input() public label: Maybe<string>;
  @Input() public placeholder: Maybe<string>;
  @Input() public readonly: Maybe<boolean>;
  @Input({ required: true }) public locale!: Locale;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }
}
